import { render, staticRenderFns } from "./FinishedAssignment.vue?vue&type=template&id=6fd4add8&scoped=true&"
import script from "./FinishedAssignment.vue?vue&type=script&lang=js&"
export * from "./FinishedAssignment.vue?vue&type=script&lang=js&"
import style0 from "./FinishedAssignment.vue?vue&type=style&index=0&id=6fd4add8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd4add8",
  null
  
)

export default component.exports